import PropTypes from 'prop-types';
import React from 'react';

function InputRadio({ checked, disabled, label, name, onChange, subtitle, value }) {
  return (
    <label className={`input-radio ${disabled ? 'input-radio--disabled' : ''}`}>
      <input
        checked={checked}
        className="input-radio__input"
        disabled={disabled}
        name={name}
        onChange={(e) => onChange(e, !checked)}
        type="radio"
        value={value}
      />
      <span className="input-radio__circle" aria-hidden="true" />
      <div className="input-radio__texts">
        <span className="input-radio__label">{label}</span>
        {subtitle && <span className="input-radio__subtitle">{subtitle}</span>}
      </div>
    </label>
  );
}

InputRadio.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  subtitle: PropTypes.string,
  value: PropTypes.string,
};

InputRadio.defaultProps = {
  checked: false,
  disabled: false,
  label: '',
  onChange: () => {},
  subtitle: '',
};

export default InputRadio;
